import GetWidgetClassNativeLanguageLookupRequestModel from '../../../generated/types/model/request/GetWidgetClassNativeLanguageLookupRequestModel';

export default class GetWidgetClassNativeLanguageLookupRequestViewModel extends GetWidgetClassNativeLanguageLookupRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
